import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRow } from "@angular/material/table";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { Router } from "@angular/router";
import * as Sentry from "@sentry/angular";
import { provideClarity } from "ngx-clarity";
import { environment } from "../environments/environment";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthInterceptor } from "./interceptors/auth.interceptor";
import { ErrorInterceptor } from "./interceptors/error.interceptor";
import {TranslateModule} from "@ngx-translate/core";
import {provideTranslateHttpLoader} from "@ngx-translate/http-loader";
import {NotificationService} from "./services/notification.service";

// Custom URL error handler
class UrlErrorHandler extends ErrorHandler {
  constructor(private router: Router, private notificationService: NotificationService) {
    super();
  }

  override handleError(error: any): void {
    if (error.message && error.message.includes('Invalid URL')) {
      this.notificationService.showError('Ongeldige URL');
      this.router.navigate(['/not-found']);
      return;
    }
    super.handleError(error);
  }
}


@NgModule({
  declarations: [
    AppComponent,
  ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatCardModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatInputModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatSnackBarModule,
        MatRow,
        TranslateModule.forRoot({
          defaultLanguage: 'nl'
        })
    ],
  providers: [
    ...provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json'
    }),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        subscriptSizing: 'dynamic'
      }
    },
    provideAnimationsAsync(),
    // provideClarity({
    //   enabled: environment.production,
    //   projectId: environment.clarityProjectId,
    // }),
    // {
    //   provide: ErrorHandler,
    //   useFactory: (router: Router, notificationService: NotificationService) => {
    //     // Use our custom URL error handler first, then fall back to Sentry
    //     const urlErrorHandler = new UrlErrorHandler(router, notificationService);
    //     const sentryHandler = Sentry.createErrorHandler();
    //
    //     return {
    //       handleError(error: any) {
    //         if (error.message && error.message.includes('Invalid URL')) {
    //           urlErrorHandler.handleError(error);
    //         } else {
    //           // Show error in snackbar for non-HTTP errors
    //           if (!(error.rejection && error.rejection.status)) {
    //             const errorMessage = error.message || 'Er is een onverwachte fout opgetreden';
    //             notificationService.showError(errorMessage);
    //           }
    //           sentryHandler.handleError(error);
    //         }
    //       }
    //     };
    //   },
    //   deps: [Router, NotificationService]
    // },
    // {
    //   provide: Sentry.TraceService,
    //   deps: [Router],
    // },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

